import * as React from 'react';
const SvgMetaSingleVideo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.01}
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#CDF"
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#27F"
      d="M19.67 5.64c-.29-.56-.75-1.02-1.31-1.31C17.72 4 16.88 4 15.2 4H8.8c-1.68 0-2.52 0-3.16.33-.56.29-1.02.75-1.31 1.31C4 6.28 4 7.12 4 8.8v6.4c0 1.68 0 2.52.33 3.16.29.56.75 1.02 1.31 1.31.64.33 1.48.33 3.16.33h6.4c1.68 0 2.52 0 3.16-.33.56-.29 1.02-.75 1.31-1.31.33-.64.33-1.48.33-3.16V8.8c0-1.68 0-2.52-.33-3.16"
    />
    <path
      fill="#fff"
      d="M15.625 11.345 10.17 8.11C9.655 7.805 9 8.171 9 8.765v6.47c0 .594.655.96 1.17.655l5.455-3.235a.76.76 0 0 0 0-1.31"
    />
  </svg>
);
export default SvgMetaSingleVideo;
